<script lang="ts">
	import { resolveAny } from '$lib/shared/lib';
	interface Props {
		url: string;
		text: string;
	}

	let { url, text }: Props = $props();
</script>

<span class="text-sm font-bold text-primary-500">
	<a href={resolveAny(url)}>{text}</a>
</span>
